export const CUSTOM_GROUP_UNGROUP_CONTROL_ID = 'custom-group-ungroup-control';
export const CUSTOM_GROUP_UNGROUP_CONTROL_MARGIN = 30;
export const GROUP_UNGROUP_CONTROL_WIDTH = 83;
export const GROUP_UNGROUP_CONTROL_HEIGHT = 37;

export interface GroupUngroupAction {
  text: string;
  icon: string;
  onClick: () => void;
}
